export const VESTING_GRAPH_VESTED_COLOR = '#548CE4'; // brand-500
export const VESTING_GRAPH_UNVESTED_COLOR = '#EAF2FF'; // brand-50
export const VESTING_GRAPH_VESTED_ACTIVE_COLOR = '#3E7BDA'; // brand-600
/** Vested bars outside the hovered period, which step back so that period reads first. */
export const VESTING_GRAPH_VESTED_MUTED_COLOR = '#78A6EF'; // brand-400
export const VESTING_GRAPH_UNVESTED_ACTIVE_COLOR = '#D1E3FF'; // brand-100
/** Lighter than the unvested bars, so the unaccelerated schedule reads as a backdrop. */
export const VESTING_GRAPH_ORIGINAL_SCHEDULE_COLOR = '#F4F8FF'; // brand-25
/** Both axes are drawn as a hairline rule, unlike the far lighter plot grid. */
export const VESTING_GRAPH_AXIS_LINE_COLOR = '#667085'; // gray-500
export const VESTING_GRAPH_GRID_COLOR = '#F2F4F7'; // gray-100
export const VESTING_GRAPH_TOOLTIP_CURSOR_COLOR = '#D0D5DD'; // gray-300
export const VESTING_GRAPH_Y_AXIS_WIDTH = 44;
export const VESTING_GRAPH_HEIGHT_PX = 320;
/**
 * Slight negative floor so bars sit just above the X-axis rule instead of painting over it.
 * Tick marks still start at 0 — only the plot gutter below the baseline grows.
 */
export const VESTING_GRAPH_Y_DOMAIN_FLOOR = -0.2;
/**
 * Maps a series percent (0–100) onto the overlay `top` % for the same plot that uses
 * Y domain `[Y_DOMAIN_FLOOR, 100]`. Plain `100 - y` would ignore the baseline lift.
 */
export const vestingGraphPercentToOverlayTopPercent = (yPercent: number) =>
  ((100 - yPercent) / (100 - VESTING_GRAPH_Y_DOMAIN_FLOOR)) * 100;
/**
 * Matches Tailwind's `lg` breakpoint so the chart appears with the desktop tables,
 * not alongside the phone cards. Narrower viewports get the compact progress bar.
 */
export const VESTING_GRAPH_FULL_CHART_MIN_WIDTH_PX = 1024;
/** Below this the chart packs bars and labels tighter so they stay readable on a tablet. */
export const VESTING_GRAPH_NARROW_SCREEN_PX = 1024;
/**
 * Bars take this share of the slot they are given, leaving the rest as the gap between
 * them. Final width is clamped: few payment columns grow toward the max, dense schedules
 * shrink toward the min (and the chart scrolls once the min no longer fits).
 */
export const VESTING_GRAPH_BAR_SLOT_FILL_RATIO = 0.72;
export const VESTING_GRAPH_MIN_BAR_SIZE_PX = 8;
/** Cap so sparse schedules do not grow into fat bars. */
export const VESTING_GRAPH_MAX_BAR_SIZE_PX = 120;
/** Dedicated acceleration / expiry column — a skinny marker, not a payment-width bar. */
export const VESTING_GRAPH_EVENT_COLUMN_WIDTH_PX = 15;
/** Space a `dd/MM/yyyy` tick needs before it starts touching its neighbour. */
export const VESTING_GRAPH_AXIS_TICK_WIDTH_PX = 76;
/** Chart height the plot gives up at the bottom: the chart margin plus the axis rule. */
export const VESTING_GRAPH_PLOT_BOTTOM_INSET_PX = 9;
/**
 * Right-hand gutter of the plot. Sized so a centred last tick (date + caption) stays
 * inside the card — the holdings column clips overflow, so labels cannot hang off the edge.
 */
export const VESTING_GRAPH_PLOT_RIGHT_INSET_PX =
  Math.ceil(VESTING_GRAPH_AXIS_TICK_WIDTH_PX / 2) + 16;
/** Extra scroll range, used only when the plot already overflows. A centred Expiry */
export const VESTING_GRAPH_EVENT_BADGE_OVERFLOW_PX = 56;
